import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/lib/useLenis";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import ProductsIndex from "@/pages/ProductsIndex";
import Solutions from "@/pages/Solutions";
import IndustryPage from "@/pages/IndustryPage";
import Pricing from "@/pages/Pricing";
import Company from "@/pages/Company";
import Support from "@/pages/Support";
import RequestDemo from "@/pages/RequestDemo";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminDemos from "@/pages/admin/AdminDemos";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminLayout from "@/pages/admin/AdminLayout";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";

function SiteLayout({ children }) {
    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    );
}

function App() {
    useLenis();
    useEffect(() => {
        document.title = "Colecle Inc — One Platform. Smarter Business.";
    }, []);
    return (
        <div className="App">
            <Toaster position="top-right" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
                    <Route path="/products" element={<SiteLayout><ProductsIndex /></SiteLayout>} />
                    <Route path="/products/:slug" element={<SiteLayout><ProductPage /></SiteLayout>} />
                    <Route path="/solutions" element={<SiteLayout><Solutions /></SiteLayout>} />
                    <Route path="/solutions/:slug" element={<SiteLayout><IndustryPage /></SiteLayout>} />
                    <Route path="/pricing" element={<SiteLayout><Pricing /></SiteLayout>} />
                    <Route path="/company" element={<SiteLayout><Company /></SiteLayout>} />
                    <Route path="/support" element={<SiteLayout><Support /></SiteLayout>} />
                    <Route path="/request-demo" element={<SiteLayout><RequestDemo /></SiteLayout>} />
                    <Route path="/login" element={<SiteLayout><Login /></SiteLayout>} />
                    <Route path="/register" element={<SiteLayout><Register /></SiteLayout>} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="demos" element={<AdminDemos />} />
                        <Route path="contacts" element={<AdminContacts />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
